import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getRegistryItem, getTransactions, buyRegistryItem } from '../api';
import { dollar } from '../util';
import { useAudio } from '../context/AudioManagementContext';
import RegistryTransaction from './RegistryTransaction';
import QuantityPicker from './QuantityPicker';
import Modal from './Modal';
import Button from './Button';
import { useAuth } from '../context/AuthContext';

function RegistryModal({ show = false, onClose, id, score = 0, buyItem }) {
  const [item, setItem] = useState();
  const [transactions, setTransactions] = useState([]);
  const [amount, setAmount] = useState(1);
  const [name, setName] = useState('Anonymous');

  const { status } = useAuth();
  const { playSubmit } = useAudio();

  useEffect(() => {
    if (id) {
      getRegistryItem(id, setItem);
      getTransactions(id, setTransactions);
    }
  }, [id, setItem]);

  useEffect(() => {
    if (status?.names?.length) {
      setName(status.names.join(' & '));
    }
  }, [status]);

  if (!show) {
    return;
  }

  const onCloseWrapper = (event) => {
    if (event) {
      if (event.stopPropagation) event.stopPropagation();
      if (event.cancelable && !event.isDefaultPrevented())
        event.preventDefault();
    }
    setAmount(1);
    setItem({});
    setTransactions([]);
    onClose();
  };

  const onBuy = (event) => {
    if (event) {
      if (event.stopPropagation) event.stopPropagation();
      if (event.cancelable && !event.isDefaultPrevented())
        event.preventDefault();
    }

    buyRegistryItem(id, name, amount, () => {
      playSubmit(0.5, () => {
        buyItem((item?.cost || 0) * amount);
        getTransactions(id, setTransactions);
      });
    });
  };

  const title = item?.title || '';
  const source =
    item && item.source ? require(`../asset/img/${item.source}`) : undefined;
  const description = item?.description;
  const quantity = item?.quantity || 1;
  let sold = 0;
  const transactionElements = transactions.map((transaction) => {
    sold += transaction.amount;
    return (
      <RegistryTransaction
        name={transaction.name}
        amount={transaction.amount}
        date={transaction.date}
        key={`transaction-${transaction.date.seconds}`}
      />
    );
  });

  return (
    <Modal
      show={show}
      onClose={onCloseWrapper}
      className="registry-modal-container"
    >
      <div className="modal-contents">
        <h1 className="modal-title">{title.toUpperCase()}</h1>
        <div className="registry-modal-image-container">
          <img className="registry-modal-image" src={source} alt={source} />
        </div>
        <p>{description}</p>
        <ul className="registry-transactions">{transactionElements}</ul>
      </div>
      {quantity > sold ? (
        <div className="modal-actions">
          <p>{dollar.format((item?.cost || 0) * amount)}</p>
          {quantity - sold > 1 && (
            <QuantityPicker
              initialValue={amount}
              minValue={1}
              maxValue={quantity - sold}
              onChange={setAmount}
            />
          )}
          <Button
            className="submit pixel-corners green"
            disabled={score < (item?.cost || Number.MAX_VALUE) * amount}
            title={
              score < (item?.cost || 0) * amount ? 'You are broke' : 'Do it!'
            }
            onClick={onBuy}
          >
            BUY
          </Button>
        </div>
      ) : (
        <div className="modal-actions">
          <p>{dollar.format((item?.cost || 0) * amount)}</p>
        </div>
      )}
    </Modal>
  );
}

RegistryModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.string,
  score: PropTypes.number,
  buyItem: PropTypes.func
};

export default RegistryModal;
